import { useQuery } from "@tanstack/react-query";
import { useHistory, useParams } from "react-router-dom";
import api from "services/api";
import { IFormConfiguration, Response } from "./AppManualInsert.types";
import mockData from "./mockConfig.json";
import { useState } from "react";
import { AppManualInclusionMultistep } from "./AppManualInsert.Multistep";
import { IconButton, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

/** Utiliza mesmo objeto de config, a diferenca é q 1 vai ter um objeto a mais q a outra na hora de renderizar na tela */
export function AppManualInsertView() {
  const { workspaceId, templateId, workspaceActivityId } = useParams() as { workspaceId: string, templateId: string, workspaceActivityId: string; };
  const history = useHistory();

  const [beneficiaryType, setBeneficiaryType] = useState<"PJ" | "CLT" | null>(null);

  const { data, isFetching, isFetched, isError } = useQuery({
    queryKey: ["app_insert-manually", workspaceActivityId],
    queryFn: () => api.get<{ data: Response }>(`/v2/apps/insert-manually/${workspaceActivityId}`),
    select: (data) => data.data.data,
    // queryFn: () => Promise.resolve({ data: mockData }),
    // select: (data) => data.data as IFormConfiguration,
  });

  return (
    <>
      {!isFetched && isFetching && <div>Loading...</div>}
      {!isFetched && isError && <div>Error...</div>}
      {data && (
        <>
          {!beneficiaryType ? (
            <>
              <div style={{ width: "100%", display: "flex", flexDirection: "row", alignItems: "center" }}>
                <IconButton
                  size="small"
                  onClick={() => history.push(`/v2/workspaces/${workspaceId}/templates/${templateId}/data-governance`)}
                >
                  <ArrowBack color="primary" />
                </IconButton>
                <Typography variant="h6">Inserção manual</Typography>
              </div>
              <div style={{ width: "100%", display: "flex", flexDirection: "row", gap: "24px", cursor: "pointer", marginBottom: "400px" }}>
                <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "8px", border: "solid 1px #e6e6e6", borderRadius: "8px", padding: "16px" }} onClick={() => setBeneficiaryType("PJ")}>
                  <Typography variant="body1" style={{ fontSize: "16px", fontWeight: "700", color: "#3024E1" }}>Pessoa Jurídica (PJ)</Typography>
                  <Typography variant="subtitle2" style={{ fontSize: "14px", fontWeight: "500", color: "rgba(15, 15, 30, 0.6)"}}>Selecione essa opção para adicionar um novo beneficiário que seja Pessoa Jurídica</Typography>
                </div>
                <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "8px", border: "solid 1px #e6e6e6", borderRadius: "8px", padding: "16px" }} onClick={() => setBeneficiaryType("CLT")}>
                  <Typography variant="body1" style={{ fontSize: "16px", fontWeight: "700", color: "#3024E1" }}>Outros (CLTs, Sócios, Estagiários)</Typography>
                  <Typography variant="subtitle2" style={{ fontSize: "14px", fontWeight: "500", color: "rgba(15, 15, 30, 0.6)"}}>Selecione essa opção para adicionar um novo beneficiário que seja outros beneficiários como, CLT, Sócio, Estagiários e mais</Typography>
                </div>
              </div>
            </>
          ) : (
            //@ts-ignore
            <AppManualInclusionMultistep setCurrentView={() => {}} config={beneficiaryType === "PJ" ? data[0].values : data[1].values} isCLT={beneficiaryType === "CLT"}/>
          )}
        </>
      )}
    </>
  )
}
